import { defineMessages } from "react-intl";

const messages = defineMessages({
  // Dialog chrome
  title: {
    id: "Customer.MergeCustomers.title",
    defaultMessage: "Merge Customers",
  },
  subtitle: {
    id: "Customer.MergeCustomers.subtitle",
    defaultMessage:
      "Select two or more customers then choose which values to retain for each field",
  },
  addAnotherCustomer: {
    id: "Customer.MergeCustomers.addAnotherCustomer",
    defaultMessage: "Add another customer",
  },
  cancel: {
    id: "Customer.MergeCustomers.cancel",
    defaultMessage: "Cancel",
  },
  merge: {
    id: "Customer.MergeCustomers.merge",
    defaultMessage: "Merge",
  },
  warningTitle: {
    id: "Customer.MergeCustomers.warningTitle",
    defaultMessage:
      "This merge will modify multiple records and cannot be undone",
  },
  warningDescription: {
    id: "Customer.MergeCustomers.warningDescription",
    defaultMessage:
      "The contact details of some of the selected customers and their linked patients, family members, and wards will change. The selected customer will be notified.",
  },
  processing: {
    id: "Customer.MergeCustomers.processing",
    defaultMessage:
      "The merge is being processed. Please be patient, this may take up to two minutes.",
  },
  mergedSuccess: {
    id: "Customer.MergeCustomers.mergedSuccess",
    defaultMessage: "Customer {name} has been merged successfully",
  },
  viewCustomer: {
    id: "Customer.MergeCustomers.viewCustomer",
    defaultMessage: "View customer",
  },
  duplicateGroupsTitle: {
    id: "Customer.MergeCustomers.duplicateGroupsTitle",
    defaultMessage:
      "{count, plural, one {# duplicate patient} other {# duplicate patients}} linked to this customer must also be merged",
  },
  duplicateGroupsSubtitle: {
    id: "Customer.MergeCustomers.duplicateGroupsSubtitle",
    defaultMessage:
      "The merged customer record now contains multiple instances of the same {count, plural, one {patient} other {patients}} which need to be merged",
  },
  duplicateGroupName: {
    id: "Customer.MergeCustomers.duplicateGroupName",
    defaultMessage: "Name",
  },
  duplicateGroupDateOfBirth: {
    id: "Customer.MergeCustomers.duplicateGroupDateOfBirth",
    defaultMessage: "Date of birth",
  },
  duplicateGroupMergeNow: {
    id: "Customer.MergeCustomers.duplicateGroupMergeNow",
    defaultMessage: "Merge now",
  },
  duplicateGroupMergeButton: {
    id: "Customer.MergeCustomers.duplicateGroupMergeButton",
    defaultMessage: "Merge",
  },
  duplicateGroupConflictTitle: {
    id: "Customer.MergeCustomers.duplicateGroupConflictTitle",
    defaultMessage: "Appointment conflict needs to be resolved",
  },
  duplicateGroupConflictDescription: {
    id: "Customer.MergeCustomers.duplicateGroupConflictDescription",
    defaultMessage:
      "These patients have appointments scheduled at the same time. One of these appointments must be canceled before they can be merged.",
  },
  duplicateGroupViewAppointment: {
    id: "Customer.MergeCustomers.duplicateGroupViewAppointment",
    defaultMessage: "View appointment {index}",
  },
  duplicateGroupIsWardOf: {
    id: "Customer.MergeCustomers.duplicateGroupIsWardOf",
    defaultMessage: "Is a ward of {customerName}",
  },
  duplicateGroupIsFamilyMemberOf: {
    id: "Customer.MergeCustomers.duplicateGroupIsFamilyMemberOf",
    defaultMessage: "Is a family member of {customerName}",
  },
  duplicateGroupMergedSuccess: {
    id: "Customer.MergeCustomers.duplicateGroupMergedSuccess",
    defaultMessage: "Patient {name} has been merged successfully",
  },
  duplicateGroupViewPatient: {
    id: "Customer.MergeCustomers.duplicateGroupViewPatient",
    defaultMessage: "View patient",
  },

  // Search
  searchLabel: {
    id: "Customer.MergeCustomers.searchLabel",
    defaultMessage: "Add customer to merge",
  },
  searchMinChars: {
    id: "Customer.MergeCustomers.searchMinChars",
    defaultMessage: "Type at least 3 characters to search",
  },
  searchNoResults: {
    id: "Customer.MergeCustomers.searchNoResults",
    defaultMessage: "No customers found",
  },

  // Column header
  wards: {
    id: "Customer.MergeCustomers.wards",
    defaultMessage: "{count, plural, one {# ward} other {# wards}}",
  },
  familyMembers: {
    id: "Customer.MergeCustomers.familyMembers",
    defaultMessage:
      "{count, plural, one {# family member} other {# family members}}",
  },
  removeCustomer: {
    id: "Customer.MergeCustomers.removeCustomer",
    defaultMessage: "Remove customer from merge",
  },

  // Footer (AC12)
  footerWards: {
    id: "Customer.MergeCustomers.footerWards",
    defaultMessage: "Wards",
  },
  footerFamilyMembers: {
    id: "Customer.MergeCustomers.footerFamilyMembers",
    defaultMessage: "Family members",
  },

  // Field labels
  fieldFirstName: {
    id: "Customer.MergeCustomers.fieldFirstName",
    defaultMessage: "First name",
  },
  fieldLastName: {
    id: "Customer.MergeCustomers.fieldLastName",
    defaultMessage: "Last name",
  },
  fieldEmail: {
    id: "Customer.MergeCustomers.fieldEmail",
    defaultMessage: "Email",
  },
  fieldPhone: {
    id: "Customer.MergeCustomers.fieldPhone",
    defaultMessage: "Phone",
  },
  fieldAdditionalPhone: {
    id: "Customer.MergeCustomers.fieldAdditionalPhone",
    defaultMessage: "Additional phone",
  },
  fieldMrn: {
    id: "Customer.MergeCustomers.fieldMrn",
    defaultMessage: "MRN",
  },
  fieldDateBirth: {
    id: "Customer.MergeCustomers.fieldDateBirth",
    defaultMessage: "Date of birth",
  },
  fieldAddress: {
    id: "Customer.MergeCustomers.fieldAddress",
    defaultMessage: "Address",
  },
  fieldRace: {
    id: "Customer.MergeCustomers.fieldRace",
    defaultMessage: "Race",
  },
  fieldEthnicity: {
    id: "Customer.MergeCustomers.fieldEthnicity",
    defaultMessage: "Ethnicity",
  },
  fieldSex: {
    id: "Customer.MergeCustomers.fieldSex",
    defaultMessage: "Sex",
  },

  // Error messages
  errorCheckoutAppointment: {
    id: "Customer.MergeCustomers.errorCheckoutAppointment",
    defaultMessage:
      "One or more selected customers have an appointment in checkout status",
  },
  errorCheckoutAppointmentDesc: {
    id: "Customer.MergeCustomers.errorCheckoutAppointmentDesc",
    defaultMessage:
      "The merge cannot proceed until checkout has completed or been abandoned.",
  },
  errorRecordLocked: {
    id: "Customer.MergeCustomers.errorRecordLocked",
    defaultMessage:
      "One or more customers are currently locked due to another merge in progress.",
  },
  errorEmailMismatch: {
    id: "Customer.MergeCustomers.errorEmailMismatch",
    defaultMessage:
      "The selected customer email does not match the expected value. Please refresh and try again.",
  },
  errorPatientMergeFailed: {
    id: "Customer.MergeCustomers.errorPatientMergeFailed",
    defaultMessage:
      "The merge could not be completed. Nothing was changed — please try again.",
  },
  errorGeneric: {
    id: "Customer.MergeCustomers.errorGeneric",
    defaultMessage: "Merge failed. Please try again.",
  },
  errorMergeFailed: {
    id: "Customer.MergeCustomers.errorMergeFailed",
    defaultMessage: "Merge for customer {name} failed. Please try again.",
  },
});

export default messages;
